import React from "react";
import "./LoadingIndicator.css";

export default function LoadingIndicator() {
	return <div className="LoadingIndicator" role="progressbar" />;
}
